import { Component, Input } from '@angular/core';

import { BuildingBlockInterface } from '../building-block.interface';
import { HeadingComponentContext } from './heading-context.interface';

@Component({
    selector: 'app-heading',
    templateUrl: './heading.component.html',
    styleUrls: ['./heading.component.min.css'],
})
export class HeadingComponent implements BuildingBlockInterface {
    @Input() public context: HeadingComponentContext;
    public paddingEnabled = true;
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/heading/heading.component.ts